import React from "react";
import TopBar from "../Components/TopBar";
import "../Style/login.css";
import FooterBottom from "../Components/FooterBottom";

function Register() {
  return (
    <div className="register">
      <div className="retopbar">
        <TopBar />
      </div>
      <div className="rehead">Submit Your Email To Join Nairaland</div>

      <div className="re_down">
        <div className="re_down-top">
          Before you can join Nairaland, we need to verify your email address.
          Please enter it below:
        </div>
        <div className="re_down-bottom">
          <div className="redb_top">
            Please enter your email address and a link allowing you to reset
            your password will be emailed to you.
          </div>
          <div className="redb_down">
            Email: <input type="email" name="" id="" readOnly />{" "}
            <button>Search</button>
          </div>
          <div className="redb_downb">
            We require a Gmail, Yahoo, Hotmail or Outlook email address.
          </div>
        </div>
      </div>
      <div className="registerfoot">
        <FooterBottom />
      </div>
    </div>
  );
}

export default Register;
